import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import axios from '../components/Axios';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, IdcardOutlined } from '@ant-design/icons';
import coverImage from "../assets/cover.jpg";

function Forgetpassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onFinish = async (values) => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const payload = {
        license: values.license?.trim(),
        email: values.email?.trim(),
        newPassword: values.newPassword
      };

      const response = await axios.post('/auth/update-password', payload);
      const msg = response.data?.message || 'Your password has been updated successfully.';
      setSuccess(msg);
      message.success(msg);

      // Redirect after showing success message
      setTimeout(() => {
        navigate('/loginPage');
      }, 1500);
    } catch (err) {
      const errMsg = err.response?.data?.error || 'An error occurred while resetting your password.';
      setError(errMsg);
      console.error('Password reset error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="container">
        <div id="main-wrapper" className="container">
          <div className="row justify-content-center pt-5">
            <div className="col-xl-10">
              <div className="card border-0">
                <div className="card-body p-0">
                  <div className="row no-gutters">
                    <div className="col-lg-6">
                      <div className="p-5" style={{ minHeight: "418px" }}>
                        <h6 className="h5 mb-3">Reset Password</h6>

                        <Form
                          className="signup-form"
                          onFinish={onFinish}
                          layout="vertical"
                        >
                          {/* License Field */}
                          <Form.Item
                            name="license"
                            rules={[{ required: true, message: 'Please input your License!' }]}
                          >
                            <Input
                              prefix={<IdcardOutlined className="site-form-item-icon" />}
                              placeholder="License Key"
                              size="large"
                            />
                          </Form.Item>

                          {/* Email Field */}
                          <Form.Item
                            name="email"
                            rules={[
                              { required: true, message: 'Please input your Email!' },
                              { type: 'email', message: 'Please enter a valid email address!' }
                            ]}
                          >
                            <Input
                              prefix={<UserOutlined className="site-form-item-icon" />}
                              type="email"
                              placeholder="Email Address"
                              size="large"
                            />
                          </Form.Item>

                          {/* New Password Field */}
                          <Form.Item
                            name="newPassword"
                            rules={[
                              { required: true, message: 'Please input your new Password!' },
                              { min: 6, message: 'Password must be at least 6 characters!' }
                            ]}
                          >
                            <Input.Password
                              prefix={<LockOutlined className="site-form-item-icon" />}
                              placeholder="New Password"
                              size="large"
                            />
                          </Form.Item>

                          {/* Loading and Error/Success Display */}
                          {loading && <BeatLoader color="#1890ff" className="mb-2" />}
                          {error && <div className="alert alert-danger mb-2">{error}</div>}
                          {success && <div className="alert alert-success mb-2">{success}</div>}

                          {/* Submit Button */}
                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className="login-form-button pb-1"
                              loading={loading}
                              block
                              size="large"
                            >
                              Reset Password
                            </Button>
                            <div className="mt-3">
                              Already have an account?{" "}
                              <Link to="/loginPage" className="register-form ml-1">
                                Log in instead
                              </Link>
                            </div>
                          </Form.Item>
                        </Form>

                      </div>
                    </div>

                    <div className="col-lg-6 d-none d-lg-inline-block">
                      <img src={coverImage} alt="Cover" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forgetpassword;
